// @ts-nocheck
/* eslint-disable react/prop-types */
/**
 * DetachButton — Hover-triggered button that detaches a child node from its
 * parent group.
 *
 * Rendered inside node components when the node has a `parentId`.
 * Appears on hover, positioned to the right of the node.
 *
 * Usage inside a node component:
 *   <DetachButton nodeId={id} />
 */
import React, { memo, useCallback } from 'react';
import { useReactFlow } from 'reactflow';
import SolyticsBox from '../../../SolyticsBox';
import SolyticsButton from '../../../SolyticsButton';
import { detachNodeFromGroup } from './useGroupNodeAdoption';

const DetachButton = memo(({ nodeId, onNodeOrphaned }) => {
  const { getNodes, setNodes } = useReactFlow();

  const handleDetach = useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();
      const currentNodes = getNodes();
      detachNodeFromGroup(nodeId, setNodes, currentNodes, onNodeOrphaned);
    },
    [nodeId, setNodes, getNodes, onNodeOrphaned]
  );

  return (
    <SolyticsBox
      className="solytics-flow-detach nodrag nopan"
      position="absolute"
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      top="50%"
      right="-76px"
      pl="40px"
      zIndex={10}
      sx={{
        transform: 'translateY(-50%)',
        opacity: 0,
        visibility: 'hidden',
        transition: (t) =>
          t.transitions.create(['opacity', 'visibility'], { delay: '0.3s' }),
      }}
    >
      <SolyticsButton variant="outlined" size="small" onClick={handleDetach}>
        Detach
      </SolyticsButton>
    </SolyticsBox>
  );
});
DetachButton.displayName = 'DetachButton';

export default DetachButton;
